import React from 'react';
import PropTypes from 'prop-types';

import { useConfig } from 'Context/ConfigContext';

import {
  useClearByOnDemand,
  SUBMISSION_STATE,
} from '../Contexts/ClearByOnDemandProvider/ClearByOnDemandProvider';
import useMyExternalProfile from '../../../Domain/useMyExternalProfile';

import ClearTicketReview from './ClearTicketReview';
import ClearButton from './ClearButton';
import ClearTicketForm from './ClearTicketForm';
import ClearExitConfirmModal from './ClearExitConfirmModal';
import ClearErrorModal from './ClearErrorModal';
import ClearCompleteModal from './ClearCompleteModal';

const MODAL_ACTIVE_STATE = [
  SUBMISSION_STATE.SUBMITTING,
  SUBMISSION_STATE.REVIEWING,
  SUBMISSION_STATE.FILLING_FORM,
];

function ClearModal() {
  const [submissionState, , { reset }] = useClearByOnDemand();

  if (submissionState === SUBMISSION_STATE.COMPLETED) return <ClearCompleteModal />;

  if ([SUBMISSION_STATE.FAILED, SUBMISSION_STATE.RE_SUBMITTING].includes(submissionState)) {
    return <ClearErrorModal />;
  }

  return (
    <ClearExitConfirmModal
      muiProps={{ isActive: MODAL_ACTIVE_STATE.includes(submissionState), onClose: reset }}
    >
      {submissionState === SUBMISSION_STATE.FILLING_FORM && <ClearTicketForm />}
      {[SUBMISSION_STATE.SUBMITTING, SUBMISSION_STATE.REVIEWING].includes(submissionState) && (
        <ClearTicketReview />
      )}
    </ClearExitConfirmModal>
  );
}

const ClearByOnDemand = ({ renderButton }) => {
  const { classroom: classroomConfig } = useConfig();
  const enableClearByOnDemand = classroomConfig?.clearByOnDemand?.enable;

  const { data } = useMyExternalProfile({ fetchPolicy: 'cache-only' });
  const providerName = data?.myExternalProfile?.providerName ?? '';

  if (!enableClearByOnDemand || providerName !== 'ondemand') return null;

  return (
    <>
      <ClearButton renderButton={renderButton} />
      <ClearModal />
    </>
  );
};

ClearByOnDemand.propTypes = {
  renderButton: PropTypes.func,
};

export default ClearByOnDemand;
